// Dominoes' client registry entry (see ../registry.ts and docs/games-contract.md).

import { Dices } from 'lucide-react';
import { CardTableSet } from '../CardTableModel';
import { seatXZ, seatYaw } from '../tableLayout';
import { SEAT_NAMES } from '../../../../supabase/functions/games/dominoes.ts';
import { DOMINOES_RULES, DOMINOES_TUTORIAL_TITLE, DOMINOES_TUTORIAL_URL } from './rules';
import { DominoesOverlay } from './DominoesOverlay';
import { DominoesTable3D } from './DominoesTable3D';
import { DominoesVRPanel } from './DominoesVR';
import type { GameClientDef } from '../types';

export const dominoesClient: GameClientDef = {
  kind: 'dominoes',
  label: 'Dominoes',
  blurb: 'Double-six partner dominoes for 4 (or head-to-head for 2) — first side to 100.',
  icon: Dices,
  glyph: '⁙',
  category: 'table',
  minPlayers: 2,
  maxPlayers: 4,
  bots: true,
  seatNames: SEAT_NAMES,
  ranking: 'wins',
  chairs: [0, 1, 2, 3].map((i) => { const [x, z] = seatXZ(i); return { x, z, yaw: seatYaw(i) }; }),
  Furniture: CardTableSet,
  Table3D: DominoesTable3D,
  Overlay: DominoesOverlay,
  VRPanel: DominoesVRPanel,
  rules: DOMINOES_RULES,
  tutorial: { url: DOMINOES_TUTORIAL_URL, title: DOMINOES_TUTORIAL_TITLE },
};
